import { createFileRoute, redirect } from "@tanstack/react-router";

import { authQueries } from "@/api/resources/auth/queries";
import VerifyCompleteInvitePage from "@/components/Verification/VerifyCompleteInvitePage";

export const Route = createFileRoute("/account/verify/complete-invite")({
  beforeLoad: async ({ context }) => {
    // redirect to password request page if session not exists
    const session = await context.queryClient.ensureQueryData(authQueries.getAuthSession());
    if (!session) {
      throw redirect({
        to: "/account/password/request",
        search: {
          malformed: true,
        },
      });
    }
  },
  component: VerifyCompleteInvitePage,
});
